export default __webpack_public_path__ + "static/media/CapaLogoBetaKo.17aa0627.svg";